module.exports = __webpack_public_path__ + "media/images/area/icon_weather_2-9d9028f900f369ca3a2eba42252fe189.png";